import React from 'react'

/**
 * Toggle — Notion-style disclosure. A caret + title row reveals the body.
 * Uncontrolled by default; pass `defaultOpen` to start expanded.
 */
export function Toggle({ title, defaultOpen = false, children, className = '' }) {
  const [open, setOpen] = React.useState(defaultOpen)
  const cls = ['toggle', className].filter(Boolean).join(' ')
  return (
    <div className={cls}>
      <button className="toggle-head" onClick={() => setOpen((v) => !v)}>
        <span className={`toggle-caret ${open ? 'open' : ''}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
        {title}
      </button>
      {open && <div className="toggle-body">{children}</div>}
    </div>
  )
}
